import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/feedbacks',
  component: Management,
  redirect: '/feedbacks/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/feedbacks/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listFeedbacks
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/feedbacks/ListTable'),
          meta: {
            auth: Auth.listFeedbacks,
            tabName: 'all'
          }
        },
        {
          path: 'unread',
          component: () => import('@/views/feedbacks/ListTable'),
          meta: {
            auth: Auth.listFeedbacks,
            tabName: 'unread'
          }
        },
        {
          path: 'unprocessed',
          component: () => import('@/views/feedbacks/ListTable'),
          meta: {
            auth: Auth.listFeedbacks,
            tabName: 'unprocessed'
          }
        }
      ]
    }
  ]
}
